import React from "react";

const Image = ({ src, alt }) => {
  return (<img
    className="gatsby-image-wrapper"
    src={ src }
    alt={ alt }
    loading="lazy" 
  />);
};

export default Image;
